<template>
  <div
    class="n-block"
    :id="id"
    v-bind:style="{
      'background': 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), center / cover no-repeat url(' + image + ')'
    }"
  >
    <h2 class="heading has-text-white">{{ title }}</h2>
    <h3 class="subtitle has-text-white is-size-6 is-size-6-mobile" v-html="text" />
    <div class="n-foot">
      <router-link :to="link">
        <i :class="'mdi mdi-' + icon"></i>
        &nbsp;
        En savoir plus
      </router-link>
    </div>
  </div>
</template>

<script>
//import ProductFeatures from "../components/ProductFeatures";

export default {
  name: "ProductPreview",
  props: {
    id: String,
    title: String,
    text: String,
    link: String,
    image: String,
    color: String,
    icon: String
  },
  components: {
    //ProductFeatures
  }
};
</script>

<style scoped>
.n-block {
  position: relative;
  padding: 20px;
  float: left;
  box-sizing: border-box;
  padding-bottom: 0px;
  width: 33.33%;
  height: 50vh;
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.n-block:hover {
  transition: 0.25s;
  transform: scale(1.02);
  border-radius: 10px;
  z-index: 99999;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
}

.n-block:hover > .n-foot {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.n-foot {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #ececec;
  width: 100%;
  height: 3.5em;
  text-align: center;
  font-size: 14pt;
}

.heading {
  font-size: 22pt;
}

@media only screen and (max-width: 960px) {
  .n-block {
    width: 100% !important;
    transform: none;
    transition: none;
  }

  .n-block:hover {
    transition: none;
    transform: none;
    border-radius: 0;
    box-shadow: none;
  }

  .n-block:hover > .n-foot {
    border-radius: 0;
  }
}
</style>